import { ServerSource, ServerSourceTPConfig } from './types';

export const serverSourceToStore = (server: ServerSource) => {
  const { dgSourceTrackingPlanConfig, ...rest } = server;
  if (!dgSourceTrackingPlanConfig) {
    return {
      ...rest,
      trackingPlanConfig: undefined,
    };
  }
  const { config, trackingPlanId = '' } = dgSourceTrackingPlanConfig;
  const key = config.track && Object.keys(config.track).length > 0 ? 'track' : 'global';
  return {
    ...rest,
    trackingPlanConfig: getTrackingPlanConfig(config[key], trackingPlanId),
  };
};

const getTrackingPlanConfig = (config: ServerSourceTPConfig['track'], trackingPlanId: string) => ({
  config: {
    track: {
      dropUnplannedEvents: config?.allowUnplannedEvents === 'false',
      dropUnplannedProperties: config?.unplannedProperties === 'drop',
      dropOtherViolation: config?.anyOtherViolation === 'drop',
      propagateValidationErrors: config?.propagateValidationErrors === 'true',
      sendViolatedEventsTo: config?.sendViolatedEventsTo || '',
    },
  },
  trackingPlanId,
});
